"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUploadUrl = void 0;
const constants_1 = require("../constants");
function getUploadUrl(params) {
    return {
        method: 'GET',
        url: `/${constants_1.serverlessBaseURL}/groups/media-manager/get-upload-url`,
        params,
    };
}
exports.getUploadUrl = getUploadUrl;
//# sourceMappingURL=http.js.map